import { useCallback } from "react";
import { mediaListApi } from "../../../api/aws";


/* =========================
   MEDIA LISTS
========================= */

export default function useMediaLists() {

  /* =========================
     LISTS
  ========================= */

  const loadLists =
    useCallback(

      async (
        filters = {}
      ) => {

        const {
          data
        } =
          await mediaListApi
            .listMediaLists(
              filters
            );
          console.log(data)
        return (
          data || {
            rows: [],
            pagination: null
          }
        );

      },

      []

    );

  /* =========================
     GET
  ========================= */

  const getList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .getMediaList(
              id
            );
     
        return (
          data
        );

      },

      []

    );

  /* =========================
     CREATE
  ========================= */

  const createList =
    useCallback(

      async payload => {

        const {
          data
        } =
          await mediaListApi
            .createMediaList(
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     UPDATE
  ========================= */

  const updateList =
    useCallback(

      async (
        id,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .updateMediaList(
              id,
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     DELETE
  ========================= */

  const deleteList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .deleteMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     RESTORE
  ========================= */

  const restoreList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .restoreMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     DUPLICATE
  ========================= */

  const duplicateList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .duplicateMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     PIN
  ========================= */

  const pinList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .pinMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  const unpinList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .unpinMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     FAVORITE
  ========================= */

  const favoriteList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .favoriteMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  const unfavoriteList =
    useCallback(

      async id => {

        const {
          data
        } =
          await mediaListApi
            .unfavoriteMediaList(
              id
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     LIST MEDIA
  ========================= */

  const loadListMedia =
    useCallback(

      async (
        listId,
        filters = {}
      ) => {

        const {
          data
        } =
          await mediaListApi
            .getMediaListItems(
              listId,
              filters
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     ADD
  ========================= */

  const addMedia =
    useCallback(

      async (
        listId,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .addMediaToList(
              listId,
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     BULK ADD
  ========================= */

  const bulkAddMedia =
    useCallback(

      async (
        listId,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .bulkAddMediaToList(
              listId,
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     REMOVE
  ========================= */

  const removeMedia =
    useCallback(

      async (
        listId,
        mediaId
      ) => {

        const {
          data
        } =
          await mediaListApi
            .removeMediaFromList(
              listId,
              mediaId
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     BULK REMOVE
  ========================= */

  const bulkRemoveMedia =
    useCallback(

      async (
        listId,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .bulkRemoveMediaFromList(
              listId,
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     MOVE
  ========================= */

  const moveMedia =
    useCallback(

      async (
        listId,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .moveMediaToList(
              listId,
              payload
            );

        return (
          data
        );

      },

      []

    );

  /* =========================
     COPY
  ========================= */

  const copyMedia =
    useCallback(

      async (
        listId,
        payload
      ) => {

        const {
          data
        } =
          await mediaListApi
            .copyMediaToList(
              listId,
              payload
            );

        return (
          data
        );

      },

      []

    );

  return {

    loadLists,

    getList,

    createList,

    updateList,

    deleteList,

    restoreList,

    duplicateList,

    pinList,

    unpinList,

    favoriteList,

    unfavoriteList,

    loadListMedia,

    addMedia,

    bulkAddMedia,

    removeMedia,

    bulkRemoveMedia,

    moveMedia,

    copyMedia

  };

}